type Props = {
  text: string | JSX.Element,
  isDisabled?: boolean,
  fn?: (a?: any) => void,
  cssStyles?: string,
  propagate?: boolean,
  actionName?: string,
  notificationCount?: number
};

function Button(
  {
    text, 
    fn = () => null, 
    isDisabled = false, 
    cssStyles = '', 
    propagate = false,
    actionName,
    notificationCount
  }: Props) {

  return (
    <div className="relative inline-block">
      <button 
        type="button" 
        onClick={(e) => { if (!propagate) { e.stopPropagation(); } fn();}} 
        className={
          isDisabled ? `max-w-sm pointer-events-none focus:outline-none rounded-lg px-5 py-2.5 min-w-0 ${cssStyles}`
          : `max-w-sm font-light rounded duration-500 px-7 py-2.5 min-w-0 ${cssStyles}`
          }
        {...(actionName !== undefined && { 'data-dd-action-name': actionName })}
      >
        { text }
      </button>
      {notificationCount !== undefined && notificationCount > 0 && (
        <span className="absolute top-0 right-0 flex items-center justify-center h-5 w-5 text-xs font-bold text-white bg-red-500 rounded-full">
          {notificationCount}
        </span>
      )}
    </div>
  );
}

export default Button;
